import { useIncreasedIncome, LAYOUT_TYPE } from '@/containers/IncreasedIncome';
import { useBonusForVerification } from '@/containers/BonusForVerification';
import {
  useEveryFiveGroupA,
  LAYOUT_TYPE as LAYOUT_TYPE_EVERY,
} from '@/containers/EveryFiveGroupA';
import { useIsDesktop } from '@scramble/hooks';
import { useConfirmedAllocationStatus } from '@/hooks/shared/useConfirmedAllocationStatus';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { InviteFriendsCard } from '../InviteFriendsCard';
import { TopUpNoFeeCard } from '../TopUpNoFeeCard';
import { OffersDesktop } from './desktop';
import { OffersMobile } from './mobile';

export const Offers = () => {
  const isDesktop = useIsDesktop();
  const { status } = useRoundStatus();
  const { allocatedGroupA } = useConfirmedAllocationStatus();
  const slides = [];
  const veriffBonusCard = useBonusForVerification();
  const everyFiveGroupACard = useEveryFiveGroupA({
    amount: allocatedGroupA,
    layout: LAYOUT_TYPE_EVERY.dashboard_desktop_card,
  });
  const increasedBonusCard = useIncreasedIncome({
    layout: LAYOUT_TYPE.dashboard_desktop_card,
  });

  everyFiveGroupACard && slides.push(everyFiveGroupACard);
  increasedBonusCard && slides.push(increasedBonusCard);
  slides.push(<InviteFriendsCard />);
  veriffBonusCard && slides.push(veriffBonusCard);
  status && !status.has_previously_invested && slides.push(<TopUpNoFeeCard />);

  if (!slides.length) return null;

  return isDesktop ? (
    <OffersDesktop data={slides} />
  ) : (
    <OffersMobile data={slides} />
  );
};
